import {
  StartOfWeekOption,
  TimeFormatOption,
  DefaultDurationOption,
  CALENDAR_VIEW_TYPE,
} from "../types/account/enum";
import { PreferencesType } from "../types/account/type";
import { BlockVisibility } from "../types/block/enum";
import { inboxActiveTab } from "../types/inbox/enum";
import { DEFAULT_INBOX_ACCORDION } from "../types/inbox/type";
import { MOBILE_VIEW_TYPE } from "../types/main";
import { DEFAULT_INBOX_WIDTH } from "./inbox/inbox";

export const DefaultPreferenceOptions: PreferencesType = {
  startOfWeek: StartOfWeekOption.SUNDAY,
  timeFormat: TimeFormatOption.HOUR12,
  defaultDuration: DefaultDurationOption.MIN15,
  defaultVisibility: BlockVisibility.PUBLIC,
  selectedSpaceIds: [],
  calendarViewType: CALENDAR_VIEW_TYPE.WEEK,
  inboxAccordion: DEFAULT_INBOX_ACCORDION,
  savedInboxWidth: DEFAULT_INBOX_WIDTH,
  spaceShow: false,
  mobileView: MOBILE_VIEW_TYPE.CALENDAR,
  inboxActiveTab: inboxActiveTab.INBOX,
};
